import { createWithEqualityFn as create } from "zustand/traditional"

// Module-level store for the "What's new" drawer's open state, so triggers that
// live in a different React root than AppNavigation (e.g. the command palette)
// can open it. Mirrors app/command-palette/store.js.
export const useDiscoveryHubStore = create(set => ({
  open: false,
  setOpen: open => set({ open })
}))
